import UIkit from 'uikit';
import Swiper, {Navigation} from 'swiper';

Swiper.use([Navigation]);

export default function () {
    let slides = {};
    let reviewsContainer = UIkit.util.$$('.tm-social');

    UIkit.util.each(reviewsContainer, (container) => {
        setTimeout(() => {
            let sliderEl = UIkit.util.$('.swiper', container);

            let sliderInstance = new Swiper(sliderEl, {
                slidesPerView: 2,
                spaceBetween: 5,
                watchSlidesVisibility: true,
                /*grid: {
                    rows: 3,
                },*/
                breakpoints: {
                    576: {
                        slidesPerView: 3,
                        spaceBetween: 5,
                    },
                    768: {
                        slidesPerView: 4,
                        spaceBetween: 10,
                    },
                },
                navigation: {
                    nextEl: UIkit.util.$('.swiper-button-next', container),
                    prevEl: UIkit.util.$('.swiper-button-prev', container),
                },
                on: {
                    init: function () {
                        slides = this.slides;
                    },
                },
            });
        }, 1000);
    });
}



// WEBPACK FOOTER //
// ./scripts/tourism/socials.js